<template>
  <picture>
    <template
      v-for="(image, index) in source"
    >
      <source
        v-if="image && image.media"
        :key="index"
        :srcset="srcset(image.src)"
        :media="image.media"
        :type="type(image.src)"
        draggable="false"
      />
    </template>
    <img
      v-if="source[0]"
      loading="lazy"
      :src="src"
      :alt="source[0].alt"
      draggable="false"
      :class="{
        'image': true,
        'image--cover': cover,
        'image--contain': contain
      }"
    >
  </picture>
</template>

<script>
export default {
  name: 'PanoramaImageSource',
  props: {
    source: {
      type: Array,
      default () {
        return []
      }
    },
    cover: {
      type: Boolean,
      default: false
    },
    contain: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    src () {
      let image = this.source.find(image => !image.media)
      if (image) {
        return image.src
      }
      if (this.source[this.source.length - 1] && this.source[this.source.length - 1].src) {
        image = this.source[this.source.length - 1].src
      }
      if (typeof image === 'string') {
        return image
      }
      if (typeof image === 'object') {
        for (const prop in image) {
          return image[prop]
        }
      }
      return ''
    }
  },
  methods: {
    type (src) {
      if (typeof src === 'string') {
        if (src.includes('webp')) {
          return 'image/webp'
        }
      }
      if (typeof src === 'object') {
        for (const prop in src) {
          if (src[prop].includes('webp')) {
            return 'image/webp'
          }
        }
      }
      return 'image/jpeg'
    },
    srcset (src) {
      let result = ''
      if (typeof src === 'object') {
        for (const prop in src) {
          result += `${src[prop]} ${prop},`
        }
      }
      if (typeof src === 'string') {
        result = src
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.image {
  width: 100%;
  height: 100%;
  object-fit: none;
  &--cover {
    object-fit: cover;
  }
  &--contain {
    object-fit: contain;
  }
}
</style>
